import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { GlobalMessageType, RoutingService } from '@spartacus/core'
import { finalize } from 'rxjs/operators'
import { CreditClaimsStatus } from '../../../../models/enum/credit-claims.enum'
import { CustomRoutes } from '../../../../models/enum/custom-routes.enum'
import { SharedValue } from '../../../../models/enum/shared.enum'
import { IHistoryList } from '../../../../models/interface/history-list.interface'
import { ISharedPagination } from '../../../../models/interface/shared.interface'
import { PriceSupportAgreementService } from '../../../../services/agreement/price-support/price-support-agreement.service'
import { CreditClaimsService } from '../../../../services/creditClaims/credit-claims.service'
import { RebateClaimService } from '../../../../services/rebate-claims/rebate-claim.service'
import { CustomGlobalMessageService } from '../../../../services/shared/custom-global-message/custom-global-message.service'
import { SharedService } from '../../../../services/shared/shared.service'
import { DataConfirmModal } from '../../../shared/confirm-modal/confirm-modal.component'
import { ICustomSelectOption } from '../../../shared/custom-components/custom-select/modals/interface/custom-select.interface'
import { CustomTableColumnType } from '../../../shared/custom-components/custom-table/modals/enum/custom-table.enum'
import {
  ICustomTableColumn,
  ICustomTableHeader
} from '../../../shared/custom-components/custom-table/modals/interface/custom-table.interface'

@Component({
    selector: 'app-credit-claims-history',
    templateUrl: './credit-claims-history.component.html',
    styleUrls: ['./credit-claims-history.component.scss'],
    standalone: false
})
export class CreditClaimsHistoryComponent implements OnInit {
  public creditClaimList: IHistoryList
  public showLoaderOnPagination: boolean
  public selectedSort: string
  public selectedFilter: string
  public showLoaderWhenNavigate: boolean
  public selectedPage = 1
  public selectedSearch: string

  public filterOptions: ICustomSelectOption[] = [
    { label: 'creditClaims.statuses.APPROVED', value: CreditClaimsStatus.APPROVED },
    { label: 'creditClaims.statuses.FOR_APPROVAL', value: CreditClaimsStatus.FOR_APPROVAL },
    { label: 'creditClaims.statuses.REJECTED', value: CreditClaimsStatus.REJECTED },
    { label: 'creditClaims.statuses.PENDING', value: CreditClaimsStatus.PENDING },
    { label: 'creditClaims.statuses.UNDER_REVIEW', value: CreditClaimsStatus.UNDER_REVIEW },
    { label: 'creditClaims.statuses.SUBMITTED', value: CreditClaimsStatus.SUBMITTED },
    { label: 'creditClaims.statuses.IN_PROCESS', value: CreditClaimsStatus.IN_PROCESS },
    { label: 'creditClaims.statuses.ACTION_REQUIRED', value: CreditClaimsStatus.ACTION_REQUIRED },
    { label: 'creditClaims.statuses.COMPLETED', value: CreditClaimsStatus.COMPLETED },
    { label: 'creditClaims.statuses.REOPENED', value: CreditClaimsStatus.REOPENED },
    { label: 'creditClaims.statuses.DUPLICATE', value: CreditClaimsStatus.DUPLICATE },
    { label: 'creditClaims.statuses.CANCELLED', value: CreditClaimsStatus.CANCELLED }
  ]

  public sortOptions: ICustomSelectOption[] = [
    { label: 'creditClaims.datePlaced', value: 'byClaimDate' },
    { label: 'creditClaims.status', value: 'byStatus' }
  ]

  /**
   * CreditClaimCode is used to uniquely identify the row since tickedId doesn't always come from backend.
   * This column is not meant to be displayed.
   */
  public headers: ICustomTableHeader[] = [
    { title: 'creditClaims.datePlaced' },
    { title: 'creditClaims.ClaimNumber' },
    { title: 'creditClaims.OrderNumber' },
    { title: 'creditClaims.status' },
    { title: 'creditClaims.CreditValue' },
    { title: 'creditClaims.CreditNoteNumber' },
    { title: 'creditClaims.CustomerClaimNumberReference', cssStyle: 'display: none' },
    // { title: 'creditClaims.status' },
    { title: '', type: CustomTableColumnType.BUTTON, cssStyle: 'min-width: 67px' }
  ]

  public columns: ICustomTableColumn[] = [
    { key: 'claimDate', type: CustomTableColumnType.DATE },
    // { key: 'amount' },
    { key: 'ticketId' },
    { key: 'invoiceNumber' },
    { key: 'status', mapWith: 'creditClaims.statuses.' },
    { key: 'amount' },
    { key: 'endCustomerNo' },
    { key: 'creditClaimCode', cssStyle: 'display: none' },
    {
      key: 'actions',
      type: CustomTableColumnType.BUTTONS,
      buttons: [
        {
          title: 'shared.details',
          translate: true,
          handler: (res) => this.viewDetails(res),
          icon: 'fa fa-info-circle'
        },
        {
          key: 'downloadCreditNote',
          title: 'shared.downloadNote',
          translate: true,
          handler: (res) => this.downloadCreditNote(res.endCustomerNo),
          icon: 'fa fa-download'
        }
      ]
    }
  ]

  constructor(
    public priceSupportAgreementService: PriceSupportAgreementService,
    public creditClaimsService: CreditClaimsService,
    public globalMessageService: CustomGlobalMessageService,
    private changeDetectorRef: ChangeDetectorRef,
    public routingService: RoutingService,
    private sharedService: SharedService,
    private rebateClaimService: RebateClaimService
  ) {}

  ngOnInit(): void {
    this.selectedSort = this.sortOptions[0].value
    this.sharedService
      .getQueryParams()
      .subscribe((queryParams) => {
        if (queryParams?.page) {
          this.pageChange(queryParams.page)
        } else {
          this.pageChange(1)
        }
      })
      .unsubscribe()
  }

  public viewDetails(value: any): void {
    const queryParam = {
      [CustomRoutes.CREDIT_CLAIMS]: { page: this.selectedPage }
    }
    this.sharedService.setQueryParamsLocal(queryParam)

    // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
    this.routingService.go(
      {
        cxRoute: CustomRoutes.CREDIT_CLAIM_DETAILS,
        params: { code: value?.creditClaimCode }
        // Sagar
        // },null,{queryParams: {distributorNo: value?.distributorNo}}
      },
      { queryParams: { distributorNo: value?.distributorNo } }
    )
  }

  public pageChange(page: number): void {
    // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
    this.routingService.go(
      {
        cxRoute: CustomRoutes.CREDIT_CLAIMS
        // Sagar
        // }, null, {queryParams: {page: page}});
      },
      { queryParams: { page: page } }
    )

    this.selectedPage = page
    this.changePageData({
      pageNumber: page,
      sort: this.selectedSort,
      status: this.selectedFilter
    })
  }

  public onSearch(value): void {
    this.selectedSearch = value?.trim()
    this.changePageData({
      sort: this.selectedSort,
      creditClaimCode: this.selectedSearch
    })
  }

  public filterChange(value: string): void {
    this.selectedFilter = value
    this.changePageData({
      status: value,
      sort: this.selectedSort
    })
  }

  public sortChange(value: string): void {
    this.selectedSort = value
    this.changePageData({
      status: this.selectedFilter,
      sort: value
    })
  }

  public changePageData(params: ISharedPagination): void {
    this.showLoaderOnPagination = true
    this.creditClaimsService
      .getCreditClaims(params)
      .pipe(
        finalize(() => {
          this.showLoaderOnPagination = false
          this.changeDetectorRef.detectChanges()
        })
      )
      .subscribe((res) => {
        if (!res) {
          this.globalMessageService.add(SharedValue.errorTryAgain, GlobalMessageType.MSG_TYPE_ERROR)
        } else {
          // res.forEach(costCenter => {
          //   const sum = costCenter.items.filter(item => item.tax === '25.00')
          //   .reduce((sum, current) => sum + current.total, 0);
          //     return sum;
          //   });
          this.creditClaimList = res
          this.creditClaimList.results.forEach((Amt, index) => {
            this.creditClaimList.results[index].amount = Amt.amount.toFixed(2)
          })
        }
      })
  }

  public onSubmitNewClaimClicked(data?: DataConfirmModal): void {
    this.showLoaderWhenNavigate = true
    // TODO:Spartacus - 'RoutingService.go' changed signature.
    //Before 4.0, the object with query params could be passed in the 2nd argument.
    //Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
    this.routingService.go(
      {
        cxRoute: CustomRoutes.ORDER_HISTORY
      },
      { queryParams: { page: data } }
    )
  }

  public get showMessageWhenNoData(): boolean {
    return !this.showLoaderOnPagination
  }

  public get showLoaderOnStartupOrWhenNoData(): boolean {
    return !this.creditClaimList?.results?.length && this.showLoaderOnPagination
  }

  public downloadCreditNote(documentId: string): void {
    if (!documentId) {
      return
    }

    if (documentId.includes('384')) {
      this.rebateClaimService.downloadCreditNoteByNumber(documentId).subscribe(
        (res) => {
          this.rebateClaimService.generateCreditPDF(res)
        },
        (err) => {
          this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
        }
      )
    } else if (documentId.includes('388')) {
      this.rebateClaimService.downloadDebitNoteByNumber(documentId).subscribe(
        (res) => {
          this.rebateClaimService.generateDebitPDFForClaim(res, documentId)
        },
        (err) => {
          this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
        }
      )
    }
  }
}
